(() => {
  function initialize(root) {
    if (root.dataset.csInitialized) return;
    root.dataset.csInitialized = 'true';
    const header = root.closest('header-component');
    const position = () => header?.style.setProperty('--cs-nav-header-bottom', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
    if (root.dataset.csNavigation === 'desktop') {
      const panel = root.querySelector('.cs-nav-panel');
      const triggers = root.querySelector('.cs-nav-triggers');
      let active = 0;
      let opener = null;
      let lastTrigger = null;
      const follow = link => {
        if (!link?.getAttribute('href') || link.getAttribute('href') === '#') return false;
        window.location.assign(link.href);
        return true;
      };
      const overview = index => root.querySelector(`[data-cs-section-panel='${index}'] .cs-nav-bottom a`);
      const choose = index => {
        active = index;
        root.querySelectorAll('[data-cs-section-panel]').forEach(item => { item.hidden = Number(item.dataset.csSectionPanel) !== index; });
        root.querySelectorAll('[data-cs-section]').forEach(item => item.setAttribute('aria-pressed', String(Number(item.dataset.csSection) === index)));
        root.querySelectorAll('[data-cs-root]').forEach(item => item.setAttribute('aria-expanded', String(!panel.hidden && Number(item.dataset.csRoot) === index)));
      };
      const close = focus => {
        panel.hidden = true;
        lastTrigger = null;
        root.querySelectorAll('[aria-expanded]').forEach(item => item.setAttribute('aria-expanded', 'false'));
        if (focus) opener?.focus();
      };
      const open = (index, trigger) => {
        panel.hidden = false;
        lastTrigger = null;
        opener = trigger;
        position();
        choose(index);
        root.querySelector('[data-cs-all]').setAttribute('aria-expanded', 'true');
      };
      const compact = () => {
        root.removeAttribute('data-compact');
        if (triggers.scrollWidth > triggers.clientWidth + 1) {
          root.dataset.compact = 'true';
          if (triggers.scrollWidth > triggers.clientWidth + 1) root.dataset.compact = 'small';
        }
        position();
      };
      root.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !root.contains(button)) return;
        if (button.hasAttribute('data-cs-root')) {
          const index = Number(button.dataset.csRoot);
          if (!panel.hidden && active === index && lastTrigger === button && follow(overview(index))) return;
          open(index, button);
          lastTrigger = button;
        } else if (button.hasAttribute('data-cs-all')) {
          if (!panel.hidden) close(false); else open(active, button);
        } else if (button.hasAttribute('data-cs-section')) {
          const index = Number(button.dataset.csSection);
          if (active === index && lastTrigger === button && follow(overview(index))) return;
          choose(index);
          lastTrigger = button;
        } else if (button.hasAttribute('data-cs-category')) {
          const section = button.closest('[data-cs-section-panel]');
          const index = Number(button.dataset.csCategory);
          const category = section.querySelector(`[data-cs-category-panel='${index}']`);
          // A default-visible category is not an intentional first activation.
          if (lastTrigger === button && !category.hidden && follow(category.querySelector('.cs-nav-more'))) return;
          lastTrigger = button;
          section.querySelectorAll('[data-cs-category-panel]').forEach(item => { item.hidden = Number(item.dataset.csCategoryPanel) !== index; });
          section.querySelectorAll('[data-cs-category]').forEach(item => item.setAttribute('aria-pressed', String(Number(item.dataset.csCategory) === index)));
        } else if (button.hasAttribute('data-cs-close')) close(true);
      });
      root.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); close(true); }
        if (event.key === 'ArrowDown' && event.target.hasAttribute('data-cs-root')) {
          event.preventDefault(); open(Number(event.target.dataset.csRoot), event.target); panel.querySelector('button')?.focus();
        }
      });
      document.addEventListener('pointerdown', event => { if (!root.contains(event.target)) close(false); });
      document.addEventListener('focusin', event => { if (!root.contains(event.target)) close(false); });
      window.addEventListener('resize', () => { close(false); compact(); });
      new ResizeObserver(compact).observe(root);
      document.fonts?.ready.then(compact);
      compact();
    } else {
      const dialog = root.querySelector('dialog');
      const toggle = root.querySelector('[data-cs-mobile-open]');
      const home = root.querySelector('[data-cs-mobile-home]');
      const back = root.querySelector('[data-cs-back]');
      const heading = root.querySelector('[data-cs-mobile-heading]');
      const originalHeading = heading.textContent;
      let sectionIndex = null;
      let categoryIndex = null;
      const show = () => {
        home.hidden = sectionIndex !== null;
        back.hidden = sectionIndex === null;
        root.querySelectorAll('[data-cs-mobile-section]').forEach(section => {
          const selected = Number(section.dataset.csMobileSection) === sectionIndex;
          section.hidden = !selected;
          section.querySelector('[data-cs-mobile-categories]').hidden = categoryIndex !== null;
          section.querySelector('h2').hidden = categoryIndex !== null;
          section.querySelectorAll('[data-cs-mobile-detail]').forEach(detail => { detail.hidden = Number(detail.dataset.csMobileDetail) !== categoryIndex; });
        });
        const selectedButton = sectionIndex === null ? null : home.querySelector(`[data-cs-mobile-root='${sectionIndex}']`);
        heading.textContent = selectedButton?.textContent.trim() || originalHeading;
        const overviewLink = sectionIndex === null ? null : root.querySelector(`[data-cs-mobile-section='${sectionIndex}'] .cs-nav-bottom a`);
        if (overviewLink) heading.href = overviewLink.href; else heading.removeAttribute('href');
        dialog.scrollTop = 0;
      };
      toggle.addEventListener('click', () => {
        sectionIndex = null; categoryIndex = null; show(); position(); dialog.showModal(); toggle.setAttribute('aria-expanded', 'true');
      });
      dialog.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) { if (event.target === dialog) dialog.close(); return; }
        if (button.hasAttribute('data-cs-mobile-root')) {
          sectionIndex = Number(button.dataset.csMobileRoot); categoryIndex = null; show(); back.focus();
        } else if (button.hasAttribute('data-cs-mobile-category')) {
          categoryIndex = Number(button.dataset.csMobileCategory); show(); back.focus();
        } else if (button.hasAttribute('data-cs-back')) {
          const previous = categoryIndex;
          if (categoryIndex !== null) categoryIndex = null; else sectionIndex = null;
          show();
          const destination = sectionIndex === null ? home.querySelector('button') : root.querySelector(`[data-cs-mobile-section='${sectionIndex}'] [data-cs-mobile-category='${previous ?? 0}']`);
          destination?.focus();
        } else if (button.hasAttribute('data-cs-mobile-close')) dialog.close();
      });
      dialog.addEventListener('close', () => { toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); });
      window.addEventListener('resize', () => { position(); if (window.innerWidth >= 750 && header?.dataset.menuStyle === 'menu') dialog.close(); });
      position();
    }
  }
  const start = () => document.querySelectorAll('[data-cs-navigation]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', start);
})();
